import Vue from "vue";
import VueRouter from "vue-router";

import CheckForReload from "@lab/utils/reloader";

// Authenticated layout master
import Layout from "@/Layout/index.vue";

// Profile routes
import { profile } from "@shared/routes/user.profile";
// We need to set the components layout
profile.component = Layout;

// Authenticated views
import HomePage from "@/views/Home.vue";

const Dashboards = () =>
	import(/* webpackChunkName: "dashboards" */ "@/views/Dashboards/index.vue");
const Charts = () =>
	import(/* webpackChunkName: "charts" */ "@/views/Charts/index.vue");

const TokensPage = () =>
	import(/* webpackChunkName: "tokenspage"*/ "@/views/Tokens/index.vue");

Vue.use(VueRouter);

const routes = [
	profile,
	{
		path: "/",
		component: Layout,
		children: [
			{
				path: "",
				name: "HomePage",
				component: HomePage
			}
		]
	},
	{
		path: "/settings",
		component: Layout,
		children: [
			{
				path: "",
				name: "settings.index",
				component: TokensPage
			}
		]
	},
	{
		path: "/dashboards",
		component: Layout,
		children: [
			{
				path: "",
				name: "dashboards.index",
				component: Dashboards,
				meta: {
					title: "DailyData - Dashboards"
				}
			},
			{
				path: ":id/view",
				name: "dashboards.view",
				component: Dashboards,
				meta: {
					title: "DailyData - Dashboards"
				}
			}
		]
	},
	{
		path: "/charts",
		component: Layout,
		children: [
			{
				path: "",
				name: "charts.index",
				component: Charts,
				meta: {
					title: "DailyData - Charts"
				}
			},
			{
				path: "view/:chartname",
				name: "charts.view",
				component: Charts,
				meta: {
					title: "DailyData - Charts"
				}
			}
		]
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

function isLoggedIn() {
	if (window.localStorage) {
		return !!window.localStorage.getItem("token");
	}
	return false;
}

// Some middleware to help us ensure the user is authenticated.
// Put noAuth: true on only route that doesn't require auth
router.beforeEach((to, from, next) => {
	// If they aren't logged in then, redirect to /login and set query for redirect
	const noAuth = to.meta && to.meta.noAuth;
	// For some reason we are getting a double redirect to the login page.
	const isLoginPage = to.name === "Login";

	if (!isLoginPage && !noAuth && !isLoggedIn()) {
		// IE/Edge fix. They are setting the no / path to be '/undefined'
		const nextPath = to.fullPath === "/undefined" ? undefined : to.fullPath;
		next({
			name: "Login",
			query: {
				redirect: nextPath
			}
		});
	} else {
		CheckForReload();
		if (to.meta.title) {
			document.title = to.meta.title;
		} else {
			document.title = `DailyData`;
		}
		next();
	}
});

export default router;
